import { render, staticRenderFns } from "./saldiscountrec.vue?vue&type=template&id=77916a12&scoped=true&"
import script from "./saldiscountrec.vue?vue&type=script&lang=js&"
export * from "./saldiscountrec.vue?vue&type=script&lang=js&"
import style0 from "./saldiscountrec.vue?vue&type=style&index=0&id=77916a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77916a12",
  null
  
)

export default component.exports